(() => {
  document.querySelectorAll('.aq-account-menu').forEach((menu) => {
    const trigger = menu.querySelector('summary');
    menu.querySelector('[data-aq-account-close]')?.addEventListener('click', () => { menu.open = false; trigger.focus(); });
    menu.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(menu.open)));
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { menu.open = false; trigger.focus(); }
    });
    document.addEventListener('click', (event) => { if (!menu.contains(event.target)) menu.open = false; });
    menu.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (!menu.contains(document.activeElement)) menu.open = false;
    }));
  });
})();
